import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'
import { useQuery } from '@apollo/client'
import dayjs from 'dayjs'
import { DatePicker } from 'antd'
import CentredLoader from '../../components/CentredLoader'
import { CONFORMITY_HISTORY_STATS_QUERY } from '../../graphql/ConformityHistoryStats'

const ConformityStats = (): JSX.Element => {
  const { t } = useTranslation()
  const [selectedDate, setSelectedDate] = useState(
    dayjs().startOf('month').set('hour', 12)
  )

  const { data, loading } = useQuery(CONFORMITY_HISTORY_STATS_QUERY, {
    variables: { date: selectedDate },
  })

  if (loading) return <CentredLoader />

  return (
    <div>
      <h1>{t('conformities:stats.title')}</h1>
      <Wrapper>
        <DatePicker
          onChange={date =>
            date && setSelectedDate(date.startOf('month').set('hour', 12))
          }
          picker="month"
          format="MM/YYYY"
          defaultValue={selectedDate}
        />
        <StatsBox>
          {data?.conformityHistoryStats?.map((stats: any) => (
            <StatsLine key={stats.moderator.id}>
              <span>{stats.moderator.email}</span>
              <Stats>{stats.treatedCount} modérations effectuées</Stats>
            </StatsLine>
          ))}
        </StatsBox>
      </Wrapper>
    </div>
  )
}

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  margin-bottom: 25px;
  height: 180px;

  .ant-select {
    margin-left: 15px;
  }
`

const StatsBox = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  padding: 50px;
`

const StatsLine = styled.div`
  display: flex;
  align-items: flex-start;
  padding: 10px;
  margin: 5px 0;
  background-color: white;
  border-radius: 8px;
`

const Stats = styled.span`
  margin-left: 30px;
  padding: 0 5px;
  border-radius: 8px;
  border-color: black;
`

export default ConformityStats
